function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonateIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.53,179s-26.31,62.79,6.7,126.93,103.57,98.78,160,128.35,116.14,16.46,145.57-30.18-8.39-80.81-6.7-147.91,12.34-84.73-22.84-142-124.8-71.12-193.9-30.08S77.53,179,77.53,179Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.53,179s-26.31,62.79,6.7,126.93,103.57,98.78,160,128.35,116.14,16.46,145.57-30.18-8.39-80.81-6.7-147.91,12.34-84.73-22.84-142-124.8-71.12-193.9-30.08S77.53,179,77.53,179Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.3,81.66c-5.43-3-7.9-.5-9.88-3s5.43-8.89-9.38-15.31c0,0-1-13.83-21.23-14.32S387,62.89,381.56,66.35s-6.91-2-12.34,1.48-3,10.37-7.41,11.36-10.37-4.44-15.8-1-5.43,6.42-7.9,6.42-7.41-2-10.37,0-6.42,4.45-6.42,4.45H446.25S447.73,84.62,442.3,81.66Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.3,81.66c-5.43-3-7.9-.5-9.88-3s5.43-8.89-9.38-15.31c0,0-1-13.83-21.23-14.32S387,62.89,381.56,66.35s-6.91-2-12.34,1.48-3,10.37-7.41,11.36-10.37-4.44-15.8-1-5.43,6.42-7.9,6.42-7.41-2-10.37,0-6.42,4.45-6.42,4.45H446.25S447.73,84.62,442.3,81.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M373.09,143.9c-3.33-1.81-4.84-.3-6-1.81s3.33-5.44-5.74-9.37c0,0-.6-8.46-13-8.76s-9.06,8.46-12.39,10.58-4.23-1.21-7.55.9-1.81,6.35-4.53,6.95-6.35-2.72-9.67-.6-3.33,3.92-4.84,3.92-4.53-1.2-6.34,0-3.93,2.72-3.93,2.72H375.5S376.41,145.71,373.09,143.9Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.09,143.9c-3.33-1.81-4.84-.3-6-1.81s3.33-5.44-5.74-9.37c0,0-.6-8.46-13-8.76s-9.06,8.46-12.39,10.58-4.23-1.21-7.55.9-1.81,6.35-4.53,6.95-6.35-2.72-9.67-.6-3.33,3.92-4.84,3.92-4.53-1.2-6.34,0-3.93,2.72-3.93,2.72H375.5S376.41,145.71,373.09,143.9Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.7,242.18s26.24,2.59,39.54,18.86c0,0,14.05-18.85,39.29-18.46a51,51,0,1,0-78.84-.36Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.7,242.18s26.24,2.59,39.54,18.86c0,0,14.05-18.85,39.29-18.46a51,51,0,1,0-78.84-.36Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.37 162.62 260.49 428.86 264.92 428.86 261.37 162.62",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7,256.08s8.86-15.95,24.81-20.82c0,0-16.84,4-25.25,17.72Z",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74,211.33s9.82-16.38,25.77-21.25c0,0-17.36,5-25.77,18.73Z",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.08,234.63s9.48-17.09,25.43-22c0,0-17.24,4.78-25.66,18.51Z",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,222.42s-8.55-15.95-23.94-20.82c0,0,16.24,4,24.37,17.72Z",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,244.56s-8.55-15.94-23.94-20.81c0,0,16.24,4,24.37,17.71Z",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.08,203.36s45.83,4.53,69.06,32.94c0,0,24.54-32.91,68.62-32.23a89.09,89.09,0,1,0-137.7-.63Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.08,203.36s45.83,4.53,69.06,32.94c0,0,24.54-32.91,68.62-32.23a89.09,89.09,0,1,0-137.7-.63Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.62 64.42 138.07 428.86 145.81 428.86 139.62 64.42",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.94,227.65s15.47-27.85,43.32-36.36c0,0-29.39,7-44.09,30.94Z",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.78,150.29s16.63-29.4,44.48-37.91c0,0-29.67,8.07-44.37,32.05Z",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.24,189.19s16.17-28.85,44-37.36c0,0-29.39,7-44.09,30.95Z",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.65,168.85S124.72,141,97.85,132.49c0,0,28.36,7,42.54,30.95Z",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.65,207.53s-14.93-27.85-41.8-36.36c0,0,28.36,7,42.54,31Z",
    style: {
      fill: "#828282"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.45,293.72c-.05,0,.59-3.19.66-3.38.74-2.29,3.51-6.26,6.19-6.25a3.17,3.17,0,0,1,3.05,3.61c-.19,1.88-1.88,3.49-3.42,4.42C406.14,293.21,401.45,293.72,401.45,293.72Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.25,272.22c2.53.9,3.78,5.58,3.7,8,0,.2-.48,3.43-.53,3.41l-.05,0c.21.74.42,1.53.63,2.4.38,1.61.79,3.44,1.11,5.45a56.88,56.88,0,0,1,.71,6.55,40,40,0,0,1-.25,7.36s0,.06,0,.09c.33-.72,1.32-2.68,1.42-2.82,1.31-2,5-5.11,7.62-4.4a3.18,3.18,0,0,1,2,4.29c-.68,1.77-2.74,2.87-4.46,3.36-1.95.56-6.28-.1-6.62-.15a56,56,0,0,1-1.6,7.33c-.39,1.41-.84,2.81-1.3,4.21l.63-1.22c1.32-2,5-5.11,7.63-4.39a3.18,3.18,0,0,1,2,4.29c-.69,1.76-2.74,2.87-4.47,3.36s-5.45,0-6.43-.13l-.54,1.61c-.89,2.56-1.78,5.12-2.59,7.65-.28.89-.52,1.78-.77,2.67.27-.54.5-1,.55-1,1.31-2,5-5.11,7.62-4.4a3.18,3.18,0,0,1,2,4.29c-.68,1.77-2.74,2.87-4.46,3.36s-5.09.06-6.26-.1c-.23.92-.46,1.84-.63,2.74-.11.62-.26,1.2-.34,1.83s-.17,1.23-.25,1.84c-.12,1.17-.26,2.38-.35,3.53-.06.8-.11,1.56-.17,2.32.27-.89.84-2.62.91-2.76a12.38,12.38,0,0,1,4.1-4.68,4.59,4.59,0,0,1,.35-.61,3.17,3.17,0,0,1,4.67-.73c2,1.75,1.53,6.57.59,8.78-.05.13-.81,1.47-1.3,2.31.36-.45.71-.89,1.09-1.35.75-.91,1.52-1.8,2.35-2.76l1.25-1.36c.41-.47.91-.91,1.36-1.36,1.08-1,2.21-2,3.38-3-.79-.66-3.6-3-4.4-4.63s-1.38-3.87-.54-5.57a3.18,3.18,0,0,1,4.51-1.42c2.27,1.42,2.5,6.26,1.91,8.58,0,.15-.65,1.77-1,2.65.71-.58,1.41-1.17,2.15-1.74,2.12-1.64,4.32-3.23,6.51-4.84.67-.48,1.33-1,2-1.48-.29-.23-3.68-3-4.58-4.77-.8-1.6-1.38-3.86-.54-5.56A3.18,3.18,0,0,1,421,317.7c2.27,1.43,2.5,6.26,1.91,8.59,0,.17-.92,2.5-1.18,3.08,1.47-1.08,2.91-2.18,4.3-3.32a55.94,55.94,0,0,0,5.31-4.95c-.13-.11-3.69-3-4.61-4.8-.8-1.6-1.38-3.86-.54-5.56a3.19,3.19,0,0,1,4.51-1.43c2.27,1.43,2.5,6.27,1.91,8.59,0,.15-.71,1.93-1.05,2.77l.13.08a40.59,40.59,0,0,0,4.36-5.86c.72-1.13,1.34-2.26,1.92-3.36-.71-.47-4-2.61-5-4.18s-1.79-3.69-1.15-5.47A3.19,3.19,0,0,1,436.2,300c2.42,1.17,3.17,6,2.84,8.33,0,.13-.34,1.42-.6,2.36.26-.5.53-1,.76-1.51.89-1.83,1.58-3.55,2.19-5.09.33-.88.62-1.68.88-2.43-.46-.82-2.3-4.14-2.48-6s.11-4.1,1.51-5.38a3.17,3.17,0,0,1,4.72.29c1.6,2.15.07,6.74-1.32,8.7-.12.17-2.3,2.6-2.32,2.55l0-.05c-.23.73-.5,1.51-.8,2.35-.57,1.55-1.23,3.3-2.08,5.16a58.41,58.41,0,0,1-3,5.85,41.39,41.39,0,0,1-4.27,6l-.06.07c.67-.41,2.58-1.51,2.73-1.57,2.21-.95,7-1.48,8.78.54a3.18,3.18,0,0,1-.7,4.68c-1.55,1.09-3.87.88-5.58.34-1.92-.62-5.18-3.55-5.43-3.78a55.58,55.58,0,0,1-5.38,5.23c-1.1,1-2.25,1.88-3.41,2.79l1.2-.67c2.21-.94,7-1.48,8.79.55a3.17,3.17,0,0,1-.71,4.67c-1.55,1.1-3.87.88-5.58.34s-4.55-3-5.29-3.65l-1.34,1c-2.15,1.65-4.31,3.29-6.38,5-.73.59-1.42,1.19-2.12,1.8l1-.58c2.2-.95,7-1.48,8.78.54a3.19,3.19,0,0,1-.7,4.68c-1.55,1.09-3.87.88-5.58.34s-4.28-2.76-5.16-3.54c-.7.64-1.4,1.28-2,1.93-.43.46-.88.87-1.29,1.35l-1.23,1.39c-.74.91-1.52,1.85-2.23,2.75-.5.63-1,1.24-1.43,1.85.72-.6,2.15-1.73,2.28-1.81,2-1.27,6.71-2.53,8.76-.79a3.18,3.18,0,0,1,0,4.73c-1.37,1.31-3.7,1.45-5.47,1.18-1.94-.31-5.47-2.61-5.91-2.9-.77,1-1.51,2-2.19,3-2.37,3.28-4.22,6.1-5.49,8.09l-.13.2L392.1,360l.26-.39c1.32-2,3.25-4.8,5.72-8.06.78-1,1.63-2.12,2.51-3.22a36.48,36.48,0,0,1-2.54-3.16c-1.89.74-5.82.77-6.33.77-.08,1.27-.15,2.5-.19,3.67-.17,4-.16,7.42-.12,9.78v.27l-1.8-.87c0-2.35.09-5.52.33-9.26.08-1.29.19-2.67.31-4.08-.5-.13-4.58-1.18-6.12-2.41s-2.88-2.93-2.83-4.82a3.19,3.19,0,0,1,3.5-3.19c2.66.34,4.9,4.64,5.33,7,0,.14.14,1.68.2,2.65.05-.58.1-1.14.16-1.73.12-1.17.27-2.34.43-3.6l.3-1.83c.09-.61.25-1.25.38-1.88.32-1.46.72-2.92,1.16-4.39-1-.1-4.67-.53-6.23-1.43s-3.28-2.46-3.52-4.34a3.18,3.18,0,0,1,3-3.68c2.68-.06,5.54,3.85,6.33,6.11.05.14.44,1.83.63,2.76.27-.88.53-1.76.83-2.64.87-2.54,1.82-5.08,2.76-7.62.29-.78.57-1.56.85-2.34-.37,0-4.71-.45-6.45-1.45-1.56-.89-3.28-2.46-3.52-4.34a3.18,3.18,0,0,1,3-3.68c2.68-.07,5.54,3.84,6.33,6.11.06.17.61,2.6.72,3.22.62-1.71,1.22-3.43,1.75-5.14a56.49,56.49,0,0,0,1.7-7.06c-.17,0-4.7-.43-6.49-1.46-1.55-.89-3.28-2.46-3.52-4.34a3.18,3.18,0,0,1,3-3.68c2.69-.06,5.54,3.85,6.33,6.11.06.15.48,2,.66,2.88H401a41.47,41.47,0,0,0,.41-7.29c0-1.34-.13-2.62-.26-3.86-.85,0-4.75,0-6.46-.74s-3.53-2.09-4-3.93a3.17,3.17,0,0,1,2.55-4c2.66-.36,5.93,3.21,7,5.37.06.12.5,1.38.81,2.3-.07-.56-.13-1.14-.2-1.68-.27-2-.65-3.83-1-5.45-.2-.91-.4-1.74-.6-2.51-.84-.42-4.21-2.19-5.36-3.61s-2.18-3.48-1.72-5.32A3.18,3.18,0,0,1,396.25,272.22Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.79,313.6c-2.11-.08-6.3-2.23-6.3-2.23s2.26-2.34,2.42-2.47c1.87-1.49,6.37-3.28,8.61-1.79a3.18,3.18,0,0,1,.56,4.69C448.87,313.27,446.57,313.68,444.79,313.6Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.45,293.72c-.05,0,.59-3.19.66-3.38.74-2.29,3.51-6.26,6.19-6.25a3.17,3.17,0,0,1,3.05,3.61c-.19,1.88-1.88,3.49-3.42,4.42C406.14,293.21,401.45,293.72,401.45,293.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.25,272.22c2.53.9,3.78,5.58,3.7,8,0,.2-.48,3.43-.53,3.41l-.05,0c.21.74.42,1.53.63,2.4.38,1.61.79,3.44,1.11,5.45a56.88,56.88,0,0,1,.71,6.55,40,40,0,0,1-.25,7.36s0,.06,0,.09c.33-.72,1.32-2.68,1.42-2.82,1.31-2,5-5.11,7.62-4.4a3.18,3.18,0,0,1,2,4.29c-.68,1.77-2.74,2.87-4.46,3.36-1.95.56-6.28-.1-6.62-.15a56,56,0,0,1-1.6,7.33c-.39,1.41-.84,2.81-1.3,4.21l.63-1.22c1.32-2,5-5.11,7.63-4.39a3.18,3.18,0,0,1,2,4.29c-.69,1.76-2.74,2.87-4.47,3.36s-5.45,0-6.43-.13l-.54,1.61c-.89,2.56-1.78,5.12-2.59,7.65-.28.89-.52,1.78-.77,2.67.27-.54.5-1,.55-1,1.31-2,5-5.11,7.62-4.4a3.18,3.18,0,0,1,2,4.29c-.68,1.77-2.74,2.87-4.46,3.36s-5.09.06-6.26-.1c-.23.92-.46,1.84-.63,2.74-.11.62-.26,1.2-.34,1.83s-.17,1.23-.25,1.84c-.12,1.17-.26,2.38-.35,3.53-.06.8-.11,1.56-.17,2.32.27-.89.84-2.62.91-2.76a12.38,12.38,0,0,1,4.1-4.68,4.59,4.59,0,0,1,.35-.61,3.17,3.17,0,0,1,4.67-.73c2,1.75,1.53,6.57.59,8.78-.05.13-.81,1.47-1.3,2.31.36-.45.71-.89,1.09-1.35.75-.91,1.52-1.8,2.35-2.76l1.25-1.36c.41-.47.91-.91,1.36-1.36,1.08-1,2.21-2,3.38-3-.79-.66-3.6-3-4.4-4.63s-1.38-3.87-.54-5.57a3.18,3.18,0,0,1,4.51-1.42c2.27,1.42,2.5,6.26,1.91,8.58,0,.15-.65,1.77-1,2.65.71-.58,1.41-1.17,2.15-1.74,2.12-1.64,4.32-3.23,6.51-4.84.67-.48,1.33-1,2-1.48-.29-.23-3.68-3-4.58-4.77-.8-1.6-1.38-3.86-.54-5.56A3.18,3.18,0,0,1,421,317.7c2.27,1.43,2.5,6.26,1.91,8.59,0,.17-.92,2.5-1.18,3.08,1.47-1.08,2.91-2.18,4.3-3.32a55.94,55.94,0,0,0,5.31-4.95c-.13-.11-3.69-3-4.61-4.8-.8-1.6-1.38-3.86-.54-5.56a3.19,3.19,0,0,1,4.51-1.43c2.27,1.43,2.5,6.27,1.91,8.59,0,.15-.71,1.93-1.05,2.77l.13.08a40.59,40.59,0,0,0,4.36-5.86c.72-1.13,1.34-2.26,1.92-3.36-.71-.47-4-2.61-5-4.18s-1.79-3.69-1.15-5.47A3.19,3.19,0,0,1,436.2,300c2.42,1.17,3.17,6,2.84,8.33,0,.13-.34,1.42-.6,2.36.26-.5.53-1,.76-1.51.89-1.83,1.58-3.55,2.19-5.09.33-.88.62-1.68.88-2.43-.46-.82-2.3-4.14-2.48-6s.11-4.1,1.51-5.38a3.17,3.17,0,0,1,4.72.29c1.6,2.15.07,6.74-1.32,8.7-.12.17-2.3,2.6-2.32,2.55l0-.05c-.23.73-.5,1.51-.8,2.35-.57,1.55-1.23,3.3-2.08,5.16a58.41,58.41,0,0,1-3,5.85,41.39,41.39,0,0,1-4.27,6l-.06.07c.67-.41,2.58-1.51,2.73-1.57,2.21-.95,7-1.48,8.78.54a3.18,3.18,0,0,1-.7,4.68c-1.55,1.09-3.87.88-5.58.34-1.92-.62-5.18-3.55-5.43-3.78a55.58,55.58,0,0,1-5.38,5.23c-1.1,1-2.25,1.88-3.41,2.79l1.2-.67c2.21-.94,7-1.48,8.79.55a3.17,3.17,0,0,1-.71,4.67c-1.55,1.1-3.87.88-5.58.34s-4.55-3-5.29-3.65l-1.34,1c-2.15,1.65-4.31,3.29-6.38,5-.73.59-1.42,1.19-2.12,1.8l1-.58c2.2-.95,7-1.48,8.78.54a3.19,3.19,0,0,1-.7,4.68c-1.55,1.09-3.87.88-5.58.34s-4.28-2.76-5.16-3.54c-.7.64-1.4,1.28-2,1.93-.43.46-.88.87-1.29,1.35l-1.23,1.39c-.74.91-1.52,1.85-2.23,2.75-.5.63-1,1.24-1.43,1.85.72-.6,2.15-1.73,2.28-1.81,2-1.27,6.71-2.53,8.76-.79a3.18,3.18,0,0,1,0,4.73c-1.37,1.31-3.7,1.45-5.47,1.18-1.94-.31-5.47-2.61-5.91-2.9-.77,1-1.51,2-2.19,3-2.37,3.28-4.22,6.1-5.49,8.09l-.13.2L392.1,360l.26-.39c1.32-2,3.25-4.8,5.72-8.06.78-1,1.63-2.12,2.51-3.22a36.48,36.48,0,0,1-2.54-3.16c-1.89.74-5.82.77-6.33.77-.08,1.27-.15,2.5-.19,3.67-.17,4-.16,7.42-.12,9.78v.27l-1.8-.87c0-2.35.09-5.52.33-9.26.08-1.29.19-2.67.31-4.08-.5-.13-4.58-1.18-6.12-2.41s-2.88-2.93-2.83-4.82a3.19,3.19,0,0,1,3.5-3.19c2.66.34,4.9,4.64,5.33,7,0,.14.14,1.68.2,2.65.05-.58.1-1.14.16-1.73.12-1.17.27-2.34.43-3.6l.3-1.83c.09-.61.25-1.25.38-1.88.32-1.46.72-2.92,1.16-4.39-1-.1-4.67-.53-6.23-1.43s-3.28-2.46-3.52-4.34a3.18,3.18,0,0,1,3-3.68c2.68-.06,5.54,3.85,6.33,6.11.05.14.44,1.83.63,2.76.27-.88.53-1.76.83-2.64.87-2.54,1.82-5.08,2.76-7.62.29-.78.57-1.56.85-2.34-.37,0-4.71-.45-6.45-1.45-1.56-.89-3.28-2.46-3.52-4.34a3.18,3.18,0,0,1,3-3.68c2.68-.07,5.54,3.84,6.33,6.11.06.17.61,2.6.72,3.22.62-1.71,1.22-3.43,1.75-5.14a56.49,56.49,0,0,0,1.7-7.06c-.17,0-4.7-.43-6.49-1.46-1.55-.89-3.28-2.46-3.52-4.34a3.18,3.18,0,0,1,3-3.68c2.69-.06,5.54,3.85,6.33,6.11.06.15.48,2,.66,2.88H401a41.47,41.47,0,0,0,.41-7.29c0-1.34-.13-2.62-.26-3.86-.85,0-4.75,0-6.46-.74s-3.53-2.09-4-3.93a3.17,3.17,0,0,1,2.55-4c2.66-.36,5.93,3.21,7,5.37.06.12.5,1.38.81,2.3-.07-.56-.13-1.14-.2-1.68-.27-2-.65-3.83-1-5.45-.2-.91-.4-1.74-.6-2.51-.84-.42-4.21-2.19-5.36-3.61s-2.18-3.48-1.72-5.32A3.18,3.18,0,0,1,396.25,272.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.79,313.6c-2.11-.08-6.3-2.23-6.3-2.23s2.26-2.34,2.42-2.47c1.87-1.49,6.37-3.28,8.61-1.79a3.18,3.18,0,0,1,.56,4.69C448.87,313.27,446.57,313.68,444.79,313.6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.29,366.14s-12.73-30.69-19.86-29.35,12.22,48.92,12.22,48.92-22.4-42.25-37.68-42.25,5.6,46.7,24.95,62.27c0,0-30.55-32.92-48.37-25.8s35.64,40.48,35.64,40.48-31.06-9.79-27.49-2.23,13.23,8.9,13.23,8.9l-35.13,1.78H460l-27.49-2.67s28.51-14.23,20.87-20-24.44,6.68-24.44,6.68,29-32,23.42-44-30.55,21.8-30.55,21.8,20.37-43.15,16.3-50.71S420.29,366.14,420.29,366.14Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.29,366.14s-12.73-30.69-19.86-29.35,12.22,48.92,12.22,48.92-22.4-42.25-37.68-42.25,5.6,46.7,24.95,62.27c0,0-30.55-32.92-48.37-25.8s35.64,40.48,35.64,40.48-31.06-9.79-27.49-2.23,13.23,8.9,13.23,8.9l-35.13,1.78H460l-27.49-2.67s28.51-14.23,20.87-20-24.44,6.68-24.44,6.68,29-32,23.42-44-30.55,21.8-30.55,21.8,20.37-43.15,16.3-50.71S420.29,366.14,420.29,366.14Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.36,367.76c-11.2,33.1-11.2,56.52-11.2,56.52s13.24.51,27-9.68",
    style: {
      fill: "none",
      stroke: "#787878",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.76,385.58a198.6,198.6,0,0,0-9.17-29",
    style: {
      fill: "none",
      stroke: "#787878",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.66,366.23l28.52,42.26s19.34-16.29,26-25.46",
    style: {
      fill: "none",
      stroke: "#787878",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.67,418.68s-30-14.26-42.26-22.41",
    style: {
      fill: "none",
      stroke: "#787878",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.9,335.32s-.67,23.35,2.23,34,9.11,34.24,10.22,39.13-.44,12.67-.44,12.67-10.9,4.9-12.23,5.34.22,1.78,2.67,2.22,20,1.34,20.9-.89.66-10,1.55-14,6.9-18,4-28-4-18.9-3.12-22.9,3.78-14.23,4.67-15.34,5.56-4.22,7.34-7.34a18.48,18.48,0,0,0,2-7.11S399.69,338.21,385.9,335.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.7,340.21a18.48,18.48,0,0,0,2-7.11s-26,5.11-39.8,2.22c0,0-.67,23.35,2.23,34s9.11,34.24,10.22,39.13a18,18,0,0,1,.38,3.31,22.68,22.68,0,0,0,12.35,1c1.44-5,6.41-17.7,3.73-27-2.89-10-4-18.9-3.12-22.9s3.78-14.23,4.67-15.34S421.92,343.33,423.7,340.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.47,424.26l-3.56-3.12s-10.9,4.9-12.23,5.34.22,1.78,2.67,2.22,20,1.34,20.9-.89a22.35,22.35,0,0,0,.71-5.25Z",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.79,248.83a13.5,13.5,0,0,1,1.78,9.34c-.89,5.56-7.34,14.45-12.23,18.9s-4.67,12-2,15.78,4,3.78,4,3.78l-8.44,39.14s14.67,2.89,25.34,2.89,13.79-.23,19.12-1.56S433,333.54,433,333.54s-8-31.57-8-40,.89-17.12.89-17.12,1.56-8.45-5.78-20.9S401,241.94,396.35,243.05A7.72,7.72,0,0,0,390.79,248.83Z",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.34,296.63s5.79,2.67,11.57.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.57,
    y1: 298.63,
    x2: 388.57,
    y2: 308.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.12,
    y1: 297.97,
    x2: 384.35,
    y2: 321.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.14,255.5c-7.33-12.45-19.12-13.56-23.79-12.45a7.72,7.72,0,0,0-5.56,5.78,13.5,13.5,0,0,1,1.78,9.34c-.75,4.68-5.44,11.72-9.83,16.49,1.6.35,4.43,0,8.28-4.26,6.22-6.9,11.11-10.9,16.89-12.68,4.2-1.29,9.57.82,13-.91C420.63,256.37,420.4,256,420.14,255.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.57,221s-1.56,4.44-1.34,7.11,1.11,4-.22,6.45-3.78,4-3.11,5.11,4,2,4,2,1.33,8.22,2.89,9.11,11.34-3.56,13.34-4.22,4.67-6.45,3.11-15.35S389,217.26,382.57,221Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.68,234c0,.8-.35,1.45-.78,1.45s-.78-.65-.78-1.45.35-1.44.78-1.44S385.68,233.25,385.68,234Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.46,230.38s2.66-1.78,4,1.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.88,218.41a1.86,1.86,0,0,0,.1,2.48,23.94,23.94,0,0,0,6,4.59c4,2,9.34,5.34,9.34,9.12s-2.22,14.67,0,18.45,8.23,7.34,11.79,7.79,8.67,4.22,10,10.45S419.48,285.52,427,284s9.11-12.23,6-17.12-6-5.11-3.56-10.45.89-12.45-4.45-16.9-9.56-2-10-7.34-2.3-12.77-6.23-18C404.29,208.13,388.38,206.68,378.88,218.41Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.46,326.65s-1.11,12.45-2,13.78-4.67,4.67-5.33,6.23S393,354,393,354s1.33,1.33,2.44.89.67-1.34.67-1.34-.67-1.33,0-1.78,3.33-1.11,4.22-3.33a27.71,27.71,0,0,0,1.34-4.89l5.56-14.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.46,276s-.44,11.33.22,16,1.12,18.46-.22,23.79-.44,12.46-.44,12.46,7.11,3.33,10.67,2.89,6-.89,6-.89,4-17.35,4.67-25.13-.89-32.24-.89-32.24",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.45,
    y: 267.08,
    width: 26.26,
    height: 28.93,
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.79,
    cy: 282.39,
    r: 9.57,
    transform: "translate(-56.87 74.53) rotate(-13.23)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.61,277.56a22.12,22.12,0,0,0,7,2.06c4,.47,5.82-.09,5.82-.09a33.76,33.76,0,0,0-.73,6.88c.08,1.85-6,2.23-9.22,1a16.42,16.42,0,0,1-4-2.16S285.67,279.81,286.61,277.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.33,279.62s4.69,3.57,12.58,2.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.86,281.69s3.79,4.15,12.65,2.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.58,283.94s7.51,4.6,13.05,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.47,279.53s3-3.29,3.85-1.22-.37,7-4.41,8.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.61,277.56s.1-2.73-1.5-3.2-1.13,6.86.37,10.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.69,239.61a61,61,0,0,0-4.13,7.78c-1,2.67-1.95,7.05-1.95,7.05l-9-4.62,5.83-15.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.2,216.27s3.65,1.22,5.11-3.16-4.14-8.51-11.92-10.7S217,207.76,214.54,213.6s-.24,12.15-3.4,16.53-14.59,5.35-15.81,17,6.08,16,4.38,20.17-8.75,6.57-7.54,15.81,14.83,14.1,20.91,10.45,8.27-11.43,6.32-20.91-2.91-19.2,2.19-22.85,10.94-10.7,11.43-14.1-.73-4.13,2.19-5.11S243.47,223.08,244.2,216.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.34,316.32s3.47,22,4.63,36.71-.42,25.44,0,34.39a250.08,250.08,0,0,0,3.47,32.09s11,4.62,12.42,5.49,3.47.87,3.47,2S242,430.2,237,428.18c-2.47-1-8.38.29-11-.87-1.67-.74,0-5.2,0-8.09S221.14,401,220,393.78s-2.31-9.53-1.44-14.74a113,113,0,0,0,1.16-11.27s-8.48-32.17-10-36.75a79.91,79.91,0,0,1-2.41-8.92",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.86,425c-1.44-.87-12.42-5.49-12.42-5.49s-1.08-5.63-2.08-14.58a14.37,14.37,0,0,1-9.33,1.61c1.53,5.71,3,11.08,3,12.68,0,2.89-1.67,7.35,0,8.09,2.61,1.16,8.52-.15,11,.87,4.91,2,13.29,0,13.29-1.16S248.31,425.87,246.86,425Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.84,421.49c-.39,2.54-1.06,5.26.21,5.82,2.61,1.16,8.52-.15,11,.87,4.91,2,13.29,0,13.29-1.16s-2-1.15-3.47-2-12.42-5.49-12.42-5.49L233.28,423Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.65,245.44a11.25,11.25,0,0,1,9.23,2.43c4.62,3.65,5.6,9.73,9.49,15.81s4.37,11.42,2.91,14.83-6.07,14.34-8.51,21.15-3.4,17.75-4.86,25-13.61,7.78-18.23,6.32-9.44-7.54-9.93-15.56,3.65-11.64,4.63-13.59,11.13-17.53,8.7-25.31-1.46-17,.25-21.63S218.19,246.17,219.65,245.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.88,247.87a11.25,11.25,0,0,0-9.23-2.43c-1.46.73-4.62,4.87-6.32,9.49s-2.68,13.85-.25,21.63-7.73,23.37-8.7,25.31c0,0,7.16,7.83,26,7.86a64.58,64.58,0,0,1,2.41-10.07c2.44-6.81,7-17.75,8.51-21.15s1-8.76-2.91-14.83S233.5,251.52,228.88,247.87Z",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.05,287.26l-36.47,3.65s-2.92-.73-3.65-2.19c-.6-1.21-12.12-20.72-16-27.28a10.93,10.93,0,0,1-1.54-7c.33-2.43,1.61-4.86,5.38-4.86,6.12,0,10.73,9.21,12.24,12.66.53,1.21,1.11,2.39,1.72,3.56l6,11.49,33.8,4.13s5.59-3.4,6.56-3.89,4.13-.72,5.84-1,2.91-1.7,2.91-.24-1.21,1.7-1.94,1.94l-3.65,1.22,9,2.2a1,1,0,0,1,.78,1.17h0a1,1,0,0,1-1.12.87l-6.47-.62,6.11,2.95a1,1,0,0,1,.45,1.27h0a1,1,0,0,1-1.08.54l-6.45-1.4,4.81,2.76,1.08,1c-.36,1.56-1.94.67-2.8.27l-3.93-1.83,3.37,3.72h0a5.27,5.27,0,0,1-3-1l-3.68-2.63-6.12-1.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.33,266.94l-.59-1.14c-.61-1.17-1.19-2.35-1.72-3.56-1.51-3.46-6.12-12.66-12.24-12.66-3.77,0-5.05,2.43-5.38,4.86a10.93,10.93,0,0,0,1.54,7L226.76,273Z",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,320.66s0,13.29,1.15,24.85,1.45,24.57.29,26.6-6.93,12.14-8.09,17.05-2,25.43-3.76,30.06-2.31,7.8-1.15,8.38,15.11,1.22,18.11,1.58,6.65-.57,6.73-1.76-5.25-3.19-9.59-6.25-4-6.87-4-9.76,6.65-20.81,12.14-33.81,10.4-45.38,10.4-50.58v-8.67",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.07,421.17c-4.35-3.06-4-6.87-4-9.76a12,12,0,0,1,.47-2.45,22.4,22.4,0,0,1-8.77-1.75c-.51,5.25-1.09,10.05-1.82,12-1.73,4.62-2.31,7.8-1.15,8.38s15.11,1.22,18.11,1.58,6.65-.57,6.73-1.76S212.41,424.23,208.07,421.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.66,427.42c.09-1.19-5.25-3.19-9.59-6.25a8.68,8.68,0,0,1-3.38-4.19,2.26,2.26,0,0,0-1.47.5c-1.16,1.16-1.44,4.63-1.44,4.63l-8.16-1.9c-1.45,4.08-1.87,6.85-.8,7.39s15.11,1.22,18.11,1.58S217.58,428.61,217.66,427.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.74,212.14s3.16,4.86,3.16,7.53-.73,4.87-.73,6.57,1.46,3.64,1.46,5.1-2.19,7.78-3.64,9.48-2.92,3.41-5.6,3.16-10-7.29-10-7.29-3.65,2.68-4.87-1.7-1.21-6.56.73-7.05a3.23,3.23,0,0,1,3.16,1s9.48-.48,12.65-5.83A28.89,28.89,0,0,0,242.74,212.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.43,236.69s7.29,7.05,10,7.29,4.14-1.45,5.6-3.16,3.64-8,3.64-9.48a11,11,0,0,0-1-3.18c-7.9,2-19.17.75-19.17.75l8.27,2.68-1.46,6.32Z",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08,226.37c0,.94-.32,1.7-.7,1.7s-.7-.76-.7-1.7.31-1.7.7-1.7S243.08,225.44,243.08,226.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.48,223.28s1-3.2,3.4-.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.54,417.36s-10.4,5.9-13.25,7.27-4.75,2.44.44,3.87,19.74.43,22.17.3,3.44.55,3.3-2.12,0-9.25,0-9.25S337,418,335.54,417.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.34,258.94s-7.54,13.37-7.78,17-.24,5.59-.24,5.59-5.84,13.86-7.78,21.15,1.46,17.75,2.92,21.15,3.16,6.57,3.16,6.57,2.67,27,2.91,35,2.92,19,3.89,26.25,3.41,19.7,3.41,19.7-2.68,1.7-2.68,2.91-.24,3.65-.24,3.65a16.85,16.85,0,0,1,4.86,1.22c3.41,1.21,10,.24,10,.24a106.17,106.17,0,0,0,1.46-13.86c0-5.35,1.94-21.64,1.21-27.23s-1.45-14.83-1.21-16,2.67-26,2.67-26a31.6,31.6,0,0,0,5.59-17.74c0-10.46-.48-12.65-.48-12.65s2.67-31.36,1.46-42.3S352.39,250,352.39,250Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.44,263.56c-1.22-10.94-7.05-13.61-7.05-13.61l-16.05,9s-7.54,13.37-7.78,17-.24,5.59-.24,5.59-5.84,13.86-7.78,21.15a20.67,20.67,0,0,0-.56,6.16c2.8,2.18,9,5.52,20.25,5,9.61-.43,15.1-3,18-5.05a25.88,25.88,0,0,0-.28-3S360.65,274.5,359.44,263.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18,206.92s-9.24,4.13-10.21,9,.73,12.16.73,13.37-3.4,4.62-2.19,5.59a3.14,3.14,0,0,0,2.43.73,72.72,72.72,0,0,0,3.65,8.27,4.1,4.1,0,0,0,4.13,2.19c.73,0,3.41-.49,3.41-.49l3.16,9.24,11.42-9s-1.94-5.34-1-8.26,5.59-7.78,6.32-14.83-6.08-15.8-11.91-16.78A18.2,18.2,0,0,0,333.18,206.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.15,205.94a18.2,18.2,0,0,0-10,1s-.82.37-2,1c2-.84,5.44-1.75,6.12,1.67,1,4.86-5.34,8-4.37,10.21s4.62,2.92,5.59,5.59,2.19,3.89,3.16,2.68.49-3.65,2.19-4.14S348,227.1,348,230s-3.16,4.14-3.16,4.14a5.37,5.37,0,0,0,4.13,2.43,1.08,1.08,0,0,1,.18,0c1.47-3,5.25-7.54,5.9-13.86C355.79,215.67,349,206.92,343.15,205.94Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.94,235.6s7.78-2.18,10-1.21-1,3.65-3.65,4.13S323.94,239.49,323.94,235.6Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.08,227.34c0,1.07-.33,1.94-.73,1.94s-.73-.87-.73-1.94.32-2,.73-2S328.08,226.26,328.08,227.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.4,223.45a2.8,2.8,0,0,1,3.89.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.13,245.57s6.07-1.46,8.5-6.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.67,256l1.7,5.34,19-11.67-2.19-6.8S335.37,252.87,333.67,256Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.2,294.44s-19.93,1.21-24.31,1.21a41,41,0,0,1-9.48-1.46s-2.43-3.4-3.4-4.37-3.16-1.22-5.35-1.22-4.13-1-4.13.49,1,1.46,1.94,1.94l2.92,1.46s-7.3.25-8.27.25-3.16-1.46-2.92.48,1.95,2.19,3.65,2.19,7.29,2.67,9,2.67,6.07.25,6.07.25,10,1.94,16.54,4.62,21.88,3.64,23.58,2.43S349,294.44,349,294.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.29,271.59,336.58,294a11.75,11.75,0,0,0,7.54,2.43,46.31,46.31,0,0,0,9.73-1.21s1.7-22.61.72-27.23-1.94-5.35-4.13-5.35",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.46,416.8s-11.74,6.11-14.64,7.54-4.83,2.57.46,4.1,20.12.49,22.59.36,3.51.59,3.36-2.24-.5-8.46-.5-8.46S120,417.5,118.46,416.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.37,415.51a30.68,30.68,0,0,1-3.14,6.28c-1.66,2.22-6.47,5-6.47,6.1V429h19.13s2.12-1.67,2.12-3-1.11-9.42-1.11-9.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.84,314.09s-3.88,12.2-7.39,24.57-7.76,27-8.5,33.07,4.25,40.45,4.25,40.45a2.76,2.76,0,0,0-1.29,2.41,7.39,7.39,0,0,0,.55,2.21s6.28,1.67,7.94,1.67a17.53,17.53,0,0,0,3.33-.37s.92-36,.92-40.27a39.58,39.58,0,0,0-.37-6.29l16.11-37.83,2.92.7s2.77,34,3.51,38.06,16.44,39,16.44,39-.55,2.77,0,4.06a5.48,5.48,0,0,1,.56,1.85,19.56,19.56,0,0,0,4.61.55,26.37,26.37,0,0,0,6.47-1.29s-.37-2.59-.92-5.17a67.93,67.93,0,0,0-2.22-7l-8.87-36s3-45.25,2.77-49.87a31,31,0,0,0-1.84-8.87S147.09,319.45,130.84,314.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.46,253.06s-9.6-.48-14.41,2.64-5.28,13.93-6,15.37-5.28,20.17-5.76,22.82,4.32,7.92,6.24,6.72S118.38,279,118.38,279s11.52,21.14,12.48,23.3-.48,13.69-.48,13.69,2.65,5,15.38,4.56,25-7.2,25-7.2-2.16-13.21-2.64-15.85-1.92-26.18-4.56-35.31-7.93-12.49-12-12.49a125.3,125.3,0,0,0-14.41.72A85.19,85.19,0,0,0,128.46,253.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.18,254.5s9.13,13.21,11.53,14.17,6-14.17,6-14.17l-1.92-11.29s-10.33,1.68-14.65,3.6S123.18,254.5,123.18,254.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.58,253.06s6.24,7.92,9.84,8.4,6,0,7.69-4.08c.95-2.32,1.2-11.29,1.2-11.29l-20.17,5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.1,221.84a19,19,0,0,0-6.25,7.44c-1.92,4.56,2.64,14.89,2.64,14.89s-1.44,8.41,1,9.13,10.57,1,15.62-1.2,7.92-6,8.16-7-.48-8.16-.48-8.16S139,229,135.19,223C133.71,220.73,122.94,218.71,119.1,221.84Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7,225.44s-1.92.48-5,4.32-3.13,9.85-3.13,9.85l-.59.41c.78,2.38,1.55,4.15,1.55,4.15s-1.44,8.41,1,9.13,10.57,1,15.62-1.2,7.92-6,8.16-7-.48-8.16-.48-8.16C133.27,225.92,122.7,225.44,122.7,225.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.23,245.13c.24-1-.48-8.16-.48-8.16s0-.07,0-.18c-11.5,10.77-24.24,7.38-24.24,7.38s-1.44,8.41,1,9.13,10.57,1,15.62-1.2S140,246.09,140.23,245.13Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,278.23c-1.55,6.07-3.44,14-3.74,15.66-.49,2.64,4.32,7.92,6.24,6.72,1.22-.76,4.85-9.26,7.35-15.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.53,291.24s-1.93,9.61-1.69,13.69,13.93,24.74,13.93,24.74l1.2-5s-4.32-19.46-4.8-23.06a59.58,59.58,0,0,1-.48-7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.8,337.47a4.72,4.72,0,0,0,.38,2.78c.67,1.14,4.6,2.29,4.69,1.62s.1-2.87.1-2.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51,335.65a4.77,4.77,0,0,0,.39,2.78c.67,1.15,4.59,2.29,4.69,1.62s.09-2.87.09-2.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.13,333.16a4.72,4.72,0,0,0,.38,2.78c.67,1.15,4.6,2.3,4.69,1.63s.1-2.88.1-2.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.49,323.43s-3.6,7.92-3.6,9.12,5,3.6,5,3.6l.24-15.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.47,
    y: 319.8,
    width: 50.13,
    height: 45,
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.06,
    cy: 345.63,
    r: 14.46,
    transform: "translate(-76.05 41.7) rotate(-13.36)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.73,338.34a33.22,33.22,0,0,0,10.64,3.12c6.1.71,8.8-.14,8.8-.14a51,51,0,0,0-1.11,10.39c.11,2.8-9.11,3.37-13.93,1.52A24,24,0,0,1,129,350S129.32,341.74,130.73,338.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.31,341.46s7.09,5.39,19,3.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6,344.58s5.73,6.28,19.1,3.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.17,348s11.35,6.95,19.72,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.17,341.32s4.54-5,5.81-1.85-.57,10.64-6.66,12.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.73,338.34s.15-4.11-2.27-4.82-1.7,10.35.57,15.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.78,
    y: 319.8,
    width: 7.5,
    height: 7.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.25,326.16l19.56-27.71a4.56,4.56,0,0,0,1.49-4.73c-.49-1.49-9.27-36.64-9.27-36.64s-4.9-8.33-10.08-3.24c-4.2,4.14-1.15,13.58.14,17,.45,1.19.86,2.39,1.23,3.61L157,294.5l-13.3,30s-5.58,2.94-6.46,3.5-2.65,3.06-3.69,4.35-2.85,1.57-1.65,2.29,2-.17,2.57-.65l2.81-2.41-2.65,8.56a1,1,0,0,0,.58,1.23h0a1,1,0,0,0,1.28-.5l2.68-5.66-.58,6.51a.93.93,0,0,0,.82,1h0a.94.94,0,0,0,1-.63l2-6-.1,5.33.26,1.37c1.47.48,1.52-1.27,1.61-2.18l.43-4.15,1.41,4.62h0a5,5,0,0,0,.71-3l-.36-4.34,1.54-5.95Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.68,275.6l-.36-1.18c-.37-1.22-.78-2.42-1.23-3.61-1.29-3.39-4.34-12.83-.14-17,5.18-5.09,10.08,3.24,10.08,3.24s1.8,7.28,3.7,14.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.41,
    y: 364.9,
    width: 71.24,
    height: 63.95,
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.97,
    cy: 399.68,
    r: 19.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.44,389.88a44.7,44.7,0,0,0,14.29,4.2c8.2.95,11.82-.19,11.82-.19s-1.73,8-1.49,14c.15,3.76-12.23,4.52-18.71,2a32.12,32.12,0,0,1-8.19-4.38S124.54,394.46,126.44,389.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.87,394.08s9.53,7.24,25.53,4.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.92,398.27s7.7,8.43,25.66,4.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.35,402.84s15.24,9.34,26.48,4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.55,393.89s6.09-6.67,7.81-2.48-.76,14.29-9,17.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.44,389.88s.2-5.52-3-6.47-2.29,13.91.76,21.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.97,
    y: 364.9,
    width: 6.32,
    height: 10.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.43,
    y: 338.37,
    width: 50.13,
    height: 45,
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.49,
    cy: 364.23,
    r: 14.46,
    transform: "translate(-84.33 30.61) rotate(-13.78)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.16,356.93a32.93,32.93,0,0,0,10.64,3.12c6.1.71,8.8-.14,8.8-.14a51,51,0,0,0-1.11,10.4c.11,2.79-9.11,3.36-13.93,1.52a24,24,0,0,1-6.1-3.26S73.75,360.34,75.16,356.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.74,360.05s7.09,5.39,19,3.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,363.18s5.73,6.28,19.11,3.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,366.58s11.35,6.95,19.72,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6,359.91s4.54-5,5.81-1.84-.56,10.64-6.66,12.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.16,356.93s.15-4.11-2.26-4.82-1.71,10.36.56,15.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.74,
    y: 338.37,
    width: 7.5,
    height: 7.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.43,
    y: 383.85,
    width: 50.13,
    height: 45,
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.49,
    cy: 409.7,
    r: 14.46,
    transform: "translate(-255.02 165.31) rotate(-42.6)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.16,402.41a33.22,33.22,0,0,0,10.64,3.12c6.1.71,8.8-.14,8.8-.14a51,51,0,0,0-1.11,10.39c.11,2.8-9.11,3.37-13.93,1.52a24,24,0,0,1-6.1-3.26S73.75,405.81,75.16,402.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.74,405.53s7.09,5.39,19,3.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,408.65s5.73,6.28,19.11,3.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,412.05S85,419,93.32,415",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6,405.39s4.54-5,5.81-1.85-.56,10.64-6.66,12.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.16,402.41s.15-4.11-2.26-4.82-1.71,10.35.56,15.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.74,
    y: 383.85,
    width: 7.5,
    height: 7.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 37.13,
    y1: 429.26,
    x2: 457.58,
    y2: 429.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1561307377727843px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonateIllustration);
export default __webpack_public_path__ + "static/media/donate-illustration.a10735c28bdfa101bd8c432687d5113e.svg";
export { ForwardRef as ReactComponent };